import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { menu } from 'src/app/enums/menu.enum';
import { IMenu } from 'src/app/interfaces/menu.model';
import { SecurityService } from 'src/app/services/security.service';
import { StoreService } from 'src/app/services/store.service';

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.scss']
})
export class SidebarComponent implements OnInit {
  rol: number = 0;
  loader: boolean = false;
  requires_billing_attention: boolean = false;

  constructor(
    private router: Router,
    public storeservice: StoreService,
    private securityservice: SecurityService
  ) { }

  ngOnInit() {
    const menu = this.storeservice.optionsListMenu.length ? this.storeservice.optionsListMenu : [];
    this.requires_billing_attention = this.storeservice.getProfile.requires_billing_attention;
    this.storeservice.optionsListMenu = menu;
  }

  getIcon(option: IMenu, isActive: boolean): string {
    if (!isActive) return option.icon;
    const parts = option.icon.split('.');
    const ext = parts.pop();
    return `${parts.join('.')}_selected.${ext}`;
  }

  pathCurrent(url:string){
    return this.router.url.includes(url) ? true : false;
  }

  goTo(url:string){
    if (url == '/logout') {
      this.logoutUser();
    }else{
      this.router.navigateByUrl(url)
    }
  }

  logoutUser(){
    this.loader = true;
    this.securityservice.logout().subscribe(
      (response)=>{
        this.loader = false;
        if (response.rtn && response.result) {
          localStorage.clear();
          this.storeservice.optionsListMenu = [];
          this.storeservice.storeProfile.next(null);
          this.router.navigateByUrl('')
        }
      }
    );
  }

  get mainMenu() {
    return this.storeservice.optionsListMenu.slice(0, this.requires_billing_attention ? -1 : -2);
  }

  get bottomMenu() {
    return this.storeservice.optionsListMenu.slice(this.requires_billing_attention ? -1 : -2);
  }
  
}
